import store from '@/store'

/**
 * 响应式rem适配方案
 * PC端：基于1920px的比例系统
 * 移动端：基于750px的比例系统
 * 判断标准：浏览器宽度 ≤ 750px 为移动端，> 750px 为PC端
 */

/**
 * 判断是否为移动端设备
 * @returns {boolean} true为移动端，false为PC端
 */
function isMobileDevice() {
    const w = document.body && document.body.clientWidth ||
        document.documentElement.clientWidth ||
        window.innerWidth;
    return w <= 750;
}

/**
 * 设置根字体大小
 * PC端：屏幕宽度 / 1920
 * 移动端：屏幕宽度 / 750
 */
function setRootFontSize() {
    const doc = document;
    const win = window;
    const w = doc.body && doc.body.clientWidth ||
        doc.documentElement.clientWidth ||
        win.innerWidth;

    let fontSize;
    if (isMobileDevice()) {
        // 移动端：基于750px
        fontSize = `${w / 750}px`;
    } else {
        // PC端：基于1920px
        fontSize = `${w / 1920}px`;
    }

    doc.documentElement.style.fontSize = fontSize;

    store.commit("SET_VALUE", {
        key: "isH5Device",
        value: isMobileDevice()
    })

     store.commit("SET_VALUE", {
        key: "isPCDevice",
        value: !isMobileDevice()
    })

    // 打印当前适配模式
    // const mode = isMobileDevice() ? '移动端(750px基准)' : 'PC端(1920px基准)';
    // console.log(`[REM] 当前适配模式: ${mode}, 屏幕宽度: ${w}px, 根字体大小: ${fontSize}`);
}

/**
 * rem转px工具函数
 * @param {number} rem - rem值
 * @returns {number} px值
 */
export function rem2px(rem) {
    const fontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    return parseFloat(rem) * fontSize;
}

/**
 * px转rem工具函数
 * @param {number} px - px值
 * @returns {number} rem值
 */
export function px2rem(px) {
    const fontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
    return parseFloat(px) / fontSize;
}

/**
 * 获取当前设备类型
 * @returns {string} 'mobile' 或 'desktop'
 */
export function getDeviceType() {
    return isMobileDevice() ? 'mobile' : 'desktop';
}

/**
 * 获取当前基准宽度
 * @returns {number} 当前基准宽度（750或1920）
 */
export function getBaseWidth() {
    return isMobileDevice() ? 750 : 1920;
}

/**
 * 初始化响应式rem适配
 */
export function initRemAdaptation() {
    const doc = document;
    const win = window;

    // 确保body已加载再设置字体
    if (doc.body) {
        setRootFontSize();
    } else {
        doc.addEventListener('DOMContentLoaded', setRootFontSize);
    }

    // 监听窗口大小改变事件
    win.addEventListener('resize', setRootFontSize, false);

    // 监听页面显示事件（从其他标签页切换回来）
    win.addEventListener('pageshow', function (e) {
        if (e.persisted) { // 如果是从缓存加载
            setRootFontSize();
        }
    }, false);

    // 为适配一些特殊场景，比如横竖屏切换，补充orientationchange事件监听
    win.addEventListener('orientationchange', setRootFontSize, false);

    // 将工具函数挂载到window对象上，方便全局使用
    win.rem2px = rem2px;
    win.px2rem = px2rem;
    win.getDeviceType = getDeviceType;
    win.getBaseWidth = getBaseWidth;
    win.isMobileDevice = isMobileDevice;

    // 打印初始化日志
    console.log('[REM] 响应式屏幕适配方案初始化完成');
    console.log('[REM] PC端基于1920px宽度计算，移动端基于750px宽度计算');
    console.log('[REM] 判断标准：浏览器宽度 ≤ 750px 为移动端，> 750px 为PC端');
}

// 默认导出初始化函数
export default initRemAdaptation; 